import { useCallback, useEffect, useRef, useState } from 'react';

export function useNavState<T>(key: string, initialValue?: T) : [T, (value: T) => void] {
  const [value, setValue] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get(key) || initialValue;
  });

  const initialRef = useRef(initialValue);
  initialRef.current = initialValue;

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (value) params.set(key, `${value}`);
    else params.delete(key);
    window.history.pushState({}, '', `${window.location.pathname}?${params.toString()}`);
  }, [value, key]);

  // O listener precisa ser a MESMA funcao no add e no remove. Antes o cleanup
  // registrava uma closure nova, que nunca batia com a registrada: cada troca
  // de passo deixava mais um listener de popstate vivo na pagina.
  const aoVoltar = useCallback(() => {
    const params = new URLSearchParams(window.location.search);
    setValue(params.get(key) || initialRef.current);
  }, [key]);

  useEffect(() => {
    window.addEventListener('popstate', aoVoltar);

    return () => window.removeEventListener('popstate', aoVoltar);
  }, [aoVoltar]);

  return [value, setValue];
}
